var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7C6 6.45 5.55 6 5 6C4.45 6 4 6.45 4 7V29C4 31.7625 6.2375 34 9 34H35C35.55 34 36 33.55 36 33C36 32.45 35.55 32 35 32H9C7.34375 32 6 30.6562 6 29V7ZM24 13C24 13.55 24.45 14 25 14H30.5875L24 20.5875L18.7063 15.2937C18.3188 14.9062 17.6812 14.9062 17.2937 15.2937L10.2937 22.2938C9.90625 22.6813 9.90625 23.3187 10.2937 23.7062C10.6812 24.0938 11.3188 24.0938 11.7063 23.7062L18 17.4125L23.2938 22.7062C23.6813 23.0938 24.3187 23.0938 24.7062 22.7062L32 15.4125V21C32 21.55 32.45 22 33 22C33.55 22 34 21.55 34 21V13C34 12.45 33.55 12 33 12H25C24.45 12 24 12.45 24 13Z",
    fill: "#DBFF6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.9d85d3139bf088a36c63b759a1f125d7.svg";
export { ForwardRef as ReactComponent };